/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { StepErrorDto } from './StepErrorDto';
import {
    StepErrorDtoFromJSON,
    StepErrorDtoFromJSONTyped,
    StepErrorDtoToJSON,
} from './StepErrorDto';

/**
 * 
 * @export
 * @interface GetErrorListDto
 */
export interface GetErrorListDto {
    /**
     * 
     * @type {string}
     * @memberof GetErrorListDto
     */
    projectId: string;
    /**
     * 
     * @type {string}
     * @memberof GetErrorListDto
     */
    stageDefinitionId: string;
    /**
     * 
     * @type {string}
     * @memberof GetErrorListDto
     */
    profileId?: string;
    /**
     * 
     * @type {Date}
     * @memberof GetErrorListDto
     */
    month?: Date;
    /**
     * 
     * @type {Array<StepErrorDto>}
     * @memberof GetErrorListDto
     */
    errors: Array<StepErrorDto>;
}

/**
 * Check if a given object implements the GetErrorListDto interface.
 */
export function instanceOfGetErrorListDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "projectId" in value;
    isInstance = isInstance && "stageDefinitionId" in value;
    isInstance = isInstance && "errors" in value;

    return isInstance;
}

export function GetErrorListDtoFromJSON(json: any): GetErrorListDto {
    return GetErrorListDtoFromJSONTyped(json, false);
}

export function GetErrorListDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetErrorListDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'projectId': json['projectId'],
        'stageDefinitionId': json['stageDefinitionId'],
        'profileId': !exists(json, 'profileId') ? undefined : json['profileId'],
        'month': !exists(json, 'month') ? undefined : (new Date(json['month'])),
        'errors': ((json['errors'] as Array<any>).map(StepErrorDtoFromJSON)),
    };
}

export function GetErrorListDtoToJSON(value?: GetErrorListDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'projectId': value.projectId,
        'stageDefinitionId': value.stageDefinitionId,
        'profileId': value.profileId,
        'month': value.month === undefined ? undefined : (value.month.toISOString()),
        'errors': ((value.errors as Array<any>).map(StepErrorDtoToJSON)),
    };
}

